module.exports = __webpack_public_path__ + "static/images/p3.d27ce63.png";